import { render, staticRenderFns } from "./CommonModal.vue?vue&type=template&id=924f7fce&scoped=true"
import script from "./CommonModal.vue?vue&type=script&lang=js"
export * from "./CommonModal.vue?vue&type=script&lang=js"
import style0 from "./CommonModal.vue?vue&type=style&index=0&id=924f7fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924f7fce",
  null
  
)

export default component.exports